var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgArtCarouselSailboat = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h60v60H0V0z",
    id: "j880brpgpa"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    xlinkHref: "#j880brpgpa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h60v60H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F1F2F2",
    fillRule: "nonzero",
    d: "m11.024 37.135 1.087 1.41 21.492 13.157 14.549 4.092.141-.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.032 37.135c.979.71 2.617 1.856 4.735 3.138 3.124 1.892 4.479 2.375 8.243 4.526 3.494 1.997 2.92 1.919 5.511 3.34 2.96 1.623 5.21 2.548 8.839 4.037 4.513 1.853 6.516 2.401 7.333 2.615a43.23 43.23 0 0 0 4.307.895 7.163 7.163 0 0 0-.485-.867c-.436-.663-.87-1.083-1.075-1.282-1.205-1.178-1.228-1.404-2.42-2.534-.535-.507-1.587-1.463-4.116-3.26a84.745 84.745 0 0 0-4.577-3.038c-6.807-4.188-10.348-6.368-15.665-9.037a149.726 149.726 0 0 0-4.543-2.185c-.643.252-1.165.486-1.529.656-2.686 1.26-4.091 2.494-4.444 2.813-.037.032-.066.06-.084.076l-.06.08.03.026v.001z",
    fill: "#F1F2F2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 36.903a68.022 68.022 0 0 0 4.675 3.177c3.086 1.915 4.424 2.405 8.14 4.583 3.45 2.022 2.883 1.943 5.442 3.382 2.924 1.643 5.145 2.579 8.727 4.086 4.456 1.876 6.433 2.43 7.24 2.647 1.746.467 3.221.74 4.253.904a7.333 7.333 0 0 0-.48-.877c-.431-.674-.86-1.097-1.062-1.3-1.19-1.193-1.214-1.421-2.391-2.566-.527-.513-1.567-1.483-4.066-3.302a82.816 82.816 0 0 0-4.521-3.075c-6.722-4.242-10.22-6.449-15.469-9.15a144.488 144.488 0 0 0-4.484-2.212c-.635.255-1.15.493-1.507.666-2.65 1.277-4.035 2.529-4.384 2.852l-.083.078-.06.08.031.027H11.5z",
    fill: "#F1F2F2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.949 37.145a65.95 65.95 0 0 0 4.475 2.996c2.955 1.808 4.238 2.275 7.799 4.332 3.305 1.91 2.76 1.833 5.212 3.193 2.8 1.553 4.933 2.443 8.37 3.877 4.276 1.784 6.175 2.317 6.952 2.525 1.676.45 3.096.717 4.087.879a6.605 6.605 0 0 0-.455-.82c-.409-.629-.819-1.026-1.01-1.216-1.137-1.12-1.156-1.333-2.28-2.406-.504-.481-1.497-1.392-3.886-3.105a79.863 79.863 0 0 0-4.327-2.899C30.45 40.5 27.1 38.416 22.067 35.857c-1.828-.93-3.34-1.648-4.3-2.097a24.4 24.4 0 0 0-1.46.605c-2.565 1.163-3.912 2.314-4.251 2.61l-.08.071-.059.075.028.025.004-.001z",
    fill: "#DE9626",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.714 41.99a278.057 278.057 0 0 1 8.199 4.691c.337.201.644-.324.307-.525a280.654 280.654 0 0 0-8.199-4.69c-.343-.19-.65.335-.307.524z",
    fill: "#DE9626",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.207 41.724c2.214 1.21 4.385 2.496 6.56 3.775l1.883 1.107c.338.2.645-.327.307-.525-2.186-1.284-4.365-2.582-6.57-3.837-.621-.353-1.246-.702-1.873-1.045-.343-.187-.651.337-.307.525z",
    fill: "#DE9626",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8AC5D",
    fillRule: "nonzero",
    d: "m27.426 43.316 5.831 3.694 1.897-1.042-5.975-3.613z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "m30.86 37.81-12.24-5.76L30.964 1.16zM33.867 38.718l14.926 12.44L31.877 1.27z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B3B5B8",
    fillRule: "nonzero",
    d: "M30.909.899h1v44h-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.484 53.6c-.013-.045-.018-.09-.52-.762-.376-.503-.726-.97-1.11-1.425-1.232-1.462-2.916-2.923-3.149-3.124-1.386-1.197-2.491-1.972-4.031-3.055a76.779 76.779 0 0 0-2.833-1.9c-2.119-1.353-3.568-2.121-6.025-3.463-5.323-2.906-5-2.84-8.971-4.956a315.118 315.118 0 0 0-4.791-2.504.169.169 0 0 0-.227.072l-.41.773M11.078 37.044v-.622a.147.147 0 0 1 .062-.145.15.15 0 0 1 .181.013l11.593 7.13 4.838 2.85 3.5 1.908a64.619 64.619 0 0 0 4.373 2.087c.912.4 2.178.95 3.816 1.567a57.408 57.408 0 0 0 5.36 1.75c1.841.5 3.06.812 4.429 1.012",
    stroke: "#F1F2F2",
    strokeWidth: 0.122
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#F1F2F2",
    strokeWidth: 0.122,
    fill: "#F1F2F2",
    fillRule: "nonzero",
    d: "m13.186 38.126.245-.49M17.102 40.568l.245-.49M21.317 43.094l.244-.488M25.395 45.592l.244-.49M29.499 47.939l.245-.49M34.852 50.026l-.097.463M40.593 52.31l-.109.683M46.432 54.073l-.054.524"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1F2F2",
    fillRule: "nonzero",
    d: "m48.181 55.22 1.698.278-.056.336-1.697-.278z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.226 39.998 1.126 1.996a2.99 2.99 0 0 0 1.014 1.134c.07.045.139.084.207.12l4.089 2.63 5.095 3.22 3.623 2.108a54.078 54.078 0 0 0 3.662 2.028c1.903.96 3.383 1.566 4.618 2.068 2.108.858 3.935 1.6 6.41 2.306A47.262 47.262 0 0 0 48.756 59l.805-2.388L34.11 51.16l-15.587-8.415-6.295-2.748-.002.001z",
    fill: "#1D3C4B",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11 37.11 1.225 2.888 2.67 1.755a310.326 310.326 0 0 0 7.952 4.914c1.601.954 2.887 1.698 3.866 2.263 1.764 1.02 2.662 1.537 3.452 1.952 1.676.88 2.937 1.423 4.581 2.133 2.064.89 3.431 1.48 5.397 2.14 2.45.82 4.341 1.249 4.9 1.373 1.684.372 3.16.598 4.334.739l.6-1.585a40.315 40.315 0 0 1-4.158-.739c-2.168-.504-3.757-1.064-5.533-1.69-1.577-.556-2.65-.993-4.794-1.866-2.468-1.005-3.47-1.482-4.229-1.865a50.635 50.635 0 0 1-2.396-1.303c-2.609-1.478-4.554-2.722-4.758-2.853-1.699-1.08-5.005-3.122-12.125-7.358",
    fill: "#BFB7B5",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48.491 54.466 1.42.3a3.984 3.984 0 0 0-.405-1.13l-.047-.096M23.078 35.049l-.082.893M29.458 38.589l-.046 1.09M36.61 42.577l-.082 1.497M43.423 47.207l-.354 1.419M48.241 51.969l-.651 1.103",
    stroke: "#F1F2F2",
    strokeWidth: 0.122
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.656 51.002c.56.363 1.047.818 1.506 1.3.23.242.453.491.675.74.221.25.44.483.589.777.177.349.703.041.525-.306-.164-.322-.41-.593-.65-.862a31.627 31.627 0 0 0-.709-.779c-.494-.519-1.026-1.004-1.629-1.395-.33-.214-.633.312-.306.525h-.001z",
    fill: "#DE9626",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1F2F2",
    fillRule: "nonzero",
    d: "M48.793 51.159 33.816 38.925l-.023-.766"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArtCarouselSailboat);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/art-carousel-sailboat.f7f11f1fb6bd6465d98859b78500ff64.svg";